// Mock data for A1C Survival Plan Landing Page

export const appStats = {
  users: "50K+",
  rating: "4.8",
  reviews: "12,000+",
  downloads: "100K+"
};

export const features = [
  {
    id: 1,
    title: "Journal",
    description: "Everything flows into one connected Journal. Medications, Meals, Activity, Hydration, Mood, and Reflection are captured as they happen.",
    icon: "BookOpen"
  },
  {
    id: 2,
    title: "Master Calendar",
    description: "Unified view of all health events across every section with smart filtering.",
    icon: "Calendar"
  },
  {
    id: 3,
    title: "Glucose & A1C Tracking",
    description: "Multi-period daily glucose readings with before/after meal tracking, plus long-term A1C monitoring with comprehensive history and trend analysis.",
    icon: "Activity"
  },
  {
    id: 4,
    title: "Fitness Activities",
    description: "Log exercises with duration, intensity, calories burned, and heart rate metrics.",
    icon: "Dumbbell"
  },
  {
    id: 5,
    title: "Nutrition Tracking",
    description: "Track meals, search nutritional databases, monitor hydration, and set daily calorie goals.",
    icon: "Apple"
  },
  {
    id: 6,
    title: "Mental Wellness",
    description: "Log your mood, receive AI-generated affirmations, and track your emotional well-being.",
    icon: "Heart"
  }
];

export const platformFeatures = [
  {
    id: 1,
    title: "For Daily Management",
    description: "Track glucose, blood pressure, weight, and medications with intelligent reminders that keep you on schedule.",
    icon: "ClipboardList"
  },
  {
    id: 2,
    title: "For Health Teams",
    description: "Manage your healthcare providers, appointments, and care systems all in one place for seamless coordination.",
    icon: "Users"
  },
  {
    id: 3,
    title: "For Active Living",
    description: "Comprehensive fitness and nutrition tracking designed specifically for diabetes-friendly wellness routines.",
    icon: "Zap"
  },
  {
    id: 4,
    title: "For Peace of Mind",
    description: "Mental wellness features including mood tracking and daily affirmations to support your emotional health journey.",
    icon: "Sparkles"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Connect Your Health Data",
    description: "Start by logging your baseline metrics - glucose levels, A1C, blood pressure, and weight. Set up your medication schedule and health team contacts."
  },
  {
    step: 2,
    title: "Track Daily Activities",
    description: "Log your meals, fitness activities, mood, and health readings throughout the day. Our intelligent calendar captures everything automatically."
  },
  {
    step: 3,
    title: "Gain Insights & Thrive",
    description: "View comprehensive health insights with visual charts and trends. Understand patterns, celebrate progress, and take control of your diabetes management."
  }
];

export const testimonials = [
  {
    id: 1,
    content: "Having glucose, meals, and activity in one place has changed how I look at my diabetes. Instead of guessing, I can see patterns over time and feel more confident about the choices I'm making.",
    rating: 5
  },
  {
    id: 2,
    content: "Managing diabetes can be mentally exhausting. The reflections and daily check-ins help me slow down and stay more balanced. It feels like the app understands that this is about more than numbers.",
    rating: 5
  },
  {
    id: 3,
    content: "I use this to help my father keep track of his health. Seeing his readings, notes, and appointments organized in one place makes it easier for our family to stay informed and prepared for doctor visits.",
    rating: 5
  },
  {
    id: 4,
    content: "Doctor appointments feel different now. Instead of trying to remember everything, I can open the app and walk through what's actually been happening day to day.",
    rating: 5
  },
  {
    id: 5,
    content: "My weeks don't look the same, and this app doesn't expect them to. Whether I'm consistent or off schedule, it helps me document real life and understand how it all connects.",
    rating: 5
  }
];

export const pressQuotes = [
  {
    quote: "A comprehensive approach to diabetes management that addresses both physical and mental wellness.",
    source: "Health Tech Review"
  },
  {
    quote: "Finally, an app that understands diabetes is more than just glucose numbers.",
    source: "Wellness Today"
  }
];
